<template>
  <div>
    <div class="div-top" @click="goEarnings">
      <span style="font-size: 20px;">今日收益</span>
      <nut-price :price="earnings.countMoney || 0.00" style="zoom: 2;" :decimalDigits="2" :needSymbol="true"
                 :thousands="true"/>
    </div>
    <div style="background: #1a87ff;display: flex;justify-content: center;">
      <div class="div-line"></div>
    </div>
    <div class="div-count">
      <div class="card-count" @click="goConsumer">
        <span style="font-size: 18px;">消费</span>
        <nut-price :price="earnings.consumerMoney || 0.00" style="zoom: 1.6;" :decimalDigits="2" :needSymbol="true"
                   :thousands="true"/>
      </div>
      <div style="height: 40px;background-color: #3CA2E2;width: 1px;"></div>
      <div class="card-count" @click="goRecharge">
        <span style="font-size: 18px;">充值</span>
        <nut-price :price="earnings.rechargePayMoney || 0.00" style="zoom: 1.6;" :decimalDigits="2" :needSymbol="true"
                   :thousands="true"/>
      </div>
    </div>
    <div style="width: 100%;background-color: white;padding-top: 10px;">
      <nut-row :gutter="8">
        <nut-col :span="8" v-if="user.role == 2">
          <div @click="goCard(1)" class="card-item" style="background-color: #1a87ff;">
            <span style="font-size: 16px;">设备管理</span>
            <span>在线 {{ (analysis.onlineCount || 0) + '/' + (analysis.countNum || 0) }} 台</span>
          </div>
        </nut-col>
        <nut-col :span="8">
          <div @click="goCard(2)" class="card-item" style="background-color: #0FCBAD;">
            <span style="font-size: 16px;">经营统计</span>
            <span>经营数据统计</span>
          </div>
        </nut-col>
        <nut-col :span="8">
          <div @click="goCard(3)" class="card-item" style="background-color: #FFA92D;">
            <span style="font-size: 16px;">会员管理</span>
            <span>会员消费记录</span>
          </div>
        </nut-col>
      </nut-row>
      <div style="margin-top: 20px; display: flex; align-items: center; width: 100%;flex-wrap: wrap;">
        <div @click="$router.push('/device/OrderList')"
             style="width: 25%;padding: 10px 0;display: flex;flex-direction: column;align-items: center;">
          <img :src="require('../../resource/img/device/svg/order.svg')" style="width: 40px;height: 40px;">
          <span style="margin-top: 5px;color: #2d2d2d;">订单查询</span>
        </div>
        <div @click="$router.push('/device/RechargeOrderList')"
             style="width: 25%;padding: 10px 0;display: flex;flex-direction: column;align-items: center;">
          <img :src="require('../../resource/img/device/svg/recharge_order.svg')" style="width: 40px;height: 40px;">
          <span style="margin-top: 5px;color: #2d2d2d;">充值订单</span>
        </div>
        <div @click="$router.push('/device/YearCardOrderList')"
             style="width: 25%;padding: 10px 0;display: flex;flex-direction: column;align-items: center;">
          <img :src="require('../../resource/img/device/svg/year_card_icon.svg')" style="width: 40px;height: 40px;">
          <span style="margin-top: 5px;color: #2d2d2d;">年卡记录</span>
        </div>
        <!--<div @click="$router.push('/device/DeviceService')"
             style="width: 25%;padding: 10px 0;display: flex;flex-direction: column;align-items: center;">
          <img :src="require('../../resource/img/device/svg/order.svg')" style="width: 40px;height: 40px;">
          <span style="margin-top: 5px;color: #2d2d2d;">设备服务</span>
        </div>-->
      </div>
    </div>
    <MTab :index="0"/>
  </div>
</template>

<script>
/**
 * 首页
 */
export default {
  name: 'DeviceHome',
  data() {
    return {
      user: {},
      //设备统计数据
      analysis: {},
      //今日收益
      earnings: {}
    }
  },
  created() {
    this.user = this.$api.user
  },
  activated() {
    this.getAnalysis ()
    this.getEarnings ()
    this.$api.getUrl ()
  },
  methods: {
    //获取今日收益
    getEarnings() {
      let date = this.$util.formatDate.format (new Date (), 'yyyy/MM/dd')
      date = date.replace (/-/g, '/')
      let startTime = new Date (date + ' 00:00:00')
      let endTime = new Date (date + ' 23:59:59')
      let data = {
        startTime: startTime.getTime () / 1000,
        endTime: endTime.getTime () / 1000
      }
      if (!this.$util.isArrOrNull (this.$api.merId)) {
        data.merId = this.$api.merId
      }
      this.$api.post ({
        url: '/device/api/device/order/earnings/find',
        data: data,
        loading: false
      }).then (res => {
        this.earnings = res.data
      })
    },
    //获取设备分析数据
    getAnalysis() {
      let data = {}
      if (!this.$util.isArrOrNull (this.$api.merId)) {
        data.merId = this.$api.merId
      }
      if (!this.$util.isArrOrNull (this.$api.user.merIds)) {
        data.merIds = this.$api.user.merIds
      }
      this.$api.post ({
        url: '/device/api/device/analysis',
        data: data,
        loading: false
      }).then (res => {
        this.analysis = res.data
      })
    },
    /**
     * 当日收益 */
    goEarnings() {
      let date = this.$util.formatDate.format (new Date (), 'yyyy/MM/dd')
      this.$router.push (`/device/Earnings?startTime=${date}&endTime=${date}`)
    },
    /**
     * 当日消费
     */
    goConsumer() {
      this.goEarnings ()
    },
    /**
     * 当日充值
     */
    goRecharge() {
      this.goEarnings ()
    },
    /**
     * 卡片点击事件
     * @param id
     */
    goCard(id) {
      switch (id) {
        case 1:
          this.$router.push ('/device/DeviceManagement')
          break
        case 2:
          this.$router.push ('/device/SiteEarnings')
          break
        case 3:
          this.$router.push ('/device/MemberList')
          break
      }
    }
  }
}
</script>

<style scoped>
.div-top {
  color: #ffffff;
  width: 100%;
  background: #1a87ff;
  height: 130px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.div-count {
  color: #ffffff;
  display: flex;
  width: 100%;
  background: #1a87ff;
  align-items: center;
  justify-content: space-around;
}

.div-count .card-count {
  margin: 15px 7px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.div-line {
  width: 90%;
  background-color: #3394ff;
  height: 1px;
}

.card-item {
  padding: 0 10px;
  color: white;
  height: 80px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/device/DeviceHome.vue